module.exports = __webpack_public_path__ + "static/img_0614-c6e73295816fdf2b3ef3a521d52aa95c.webp";